//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'
import showcaseQuery from '~/apollo/queries/product/showcase-slug'
import targetedPackagesDirectoryQuery from '~/apollo/queries/packages/targeted-packages-directory'
import targetedPackagesJsonQuery from '~/apollo/queries/packages/targeted-packages-json'

export default {
  mixins: [seo],
  data () {
    return {
      packageList: null
    }
  },
  props: {
    target: String,
    altTarget: String,
    brandTarget: String
  },
  apollo: {
    showcase: {
      prefetch: true,
      query: showcaseQuery,
      variables () {
        return { id: this.$route.query.id }
      },
      result ({ data }) {
        this.seoTitle = data.showcase.data.attributes.name
      }
    },
    targetedPackagesDirectory: {
      prefetch: true,
      query: targetedPackagesDirectoryQuery
    },
    targetedPackagesJson: {
      prefetch: true,
      query: targetedPackagesJsonQuery
    }
  },
  watch: {
    async contentUrl () {
      this.packageList = await this.$http.$get(this.$config.cmsURL + this.contentUrl)
        .then((response) => { return response })
        .catch((e) => { console.log(e.toJSON()) })
    }
  },
  computed: {
    contentUrl () {
      return (this.targetedPackagesJson && this.targetedPackagesJson.data && this.targetedPackagesJson.data.attributes.targetedPackages.data) ? this.targetedPackagesJson.data.attributes.targetedPackages.data.attributes.url : null
    },
    targetedPackageList () {
      return this.flatPackageList
        ? this.flatPackageList.filter((row) => {
          return (row.Target === this.target)
        })
        : null
    },
    flatPackageList () {
      if (!this.packageList) {
        return null
      }
      const ret = []
      const sz = this.packageList.length
      for (let i = 0; i < sz; i++) {
        let idx = this.packageList[i].Name.lastIndexOf(' (' + this.packageList[i].ECUModel + ')')
        if (idx === -1) {
          idx = this.packageList[i].Name.lastIndexOf(' [' + this.packageList[i].ECUModel + ']')
        }

        this.packageList[i].Packages.forEach((pkg) => {
          pkg.PackageAttributeSets.forEach((packageAttributeSet) => {
            const packageAttributes = packageAttributeSet.PackageAttributes

            // calc suits and full suits (from MOXMLToWeb)
            const makeObj = packageAttributes.find(obj => obj.Name === 'Make')
            const modelObj = packageAttributes.find(obj => obj.Name === 'Model')
            const modelYearsObj = packageAttributes.find(obj => obj.Name === 'Model Year')
            let make = makeObj ? makeObj.Value : null
            const model = modelObj ? modelObj.Value : null
            const modelYears = modelYearsObj ? modelYearsObj.Value : null

            let suits = model
            if (modelYears) {
              suits += ', ' + modelYears
            }
            const fullSuits = make + ' ' + suits
            const packageName = (idx === -1) ? this.packageList[i].Name : this.packageList[i].Name.substring(0, idx) + this.packageList[i].Name.substring(idx + this.packageList[i].ECUModel.length + 3)
            const packageSlug = packageName

            let duplicate = false

            // ensure no duplicates
            ret.filter(el => el.FullSuits === fullSuits).forEach((item) => {
              if ((item.PackageName === packageName) && (item.PackageSlug === packageSlug)) {
                duplicate = true
              }
            })

            if (!duplicate) {
              const integrationTypeObj = packageAttributes.find(obj => obj.Name === 'Integration Type')
              const integrationType = integrationTypeObj ? integrationTypeObj.Value : null
              const targetObj = packageAttributes.find(obj => obj.Name === 'Target')
              const target = targetObj ? targetObj.Value : null
              let owner = 'MoTeC'
              let salesEmail = 'sales@motec.com.au'
              let supportEmail = 'support@motec.com.au'
              let website = ''
              if (this.packageList[i].FirmwareOwners[0]) {
                if (!this.packageList[i].IsPublic && this.packageList[i].FirmwareOwners[0].ContactEmail) {
                  salesEmail = this.packageList[i].FirmwareOwners[0].ContactEmail
                  supportEmail = this.packageList[i].FirmwareOwners[0].ContactEmail
                }
                if (this.packageList[i].FirmwareOwners[0].Name) {
                  owner = this.packageList[i].FirmwareOwners[0].Name
                }
              }
              let firmwareSource = ''

              const salesBody = 'Price query about "' + packageName + '" for ' + fullSuits + '\n\n' +
                                      'My location is: \n' +
                                      'My project is: \n'

              const supportBody = 'Query about "' + packageName + '" for ' + fullSuits + '\n\n' +
                                      'My ECU Serial Number is: \n' +
                                      'My location is: \n' +
                                      'My question is: \n'

              const salesEmailLink = 'mailto:' + salesEmail + '?subject=' + encodeURI('Package price enquiry: ' + packageName) + '&body=' + encodeURI(salesBody)
              const supportEmailLink = 'mailto:' + supportEmail + '?subject=' + encodeURI('Package support enquiry: ' + packageName) + '&body=' + encodeURI(supportBody)

              if (this.packageList[i].ECUModel === 'M800') {
                firmwareSource = 'M800'
              } else if (this.packageList[i].ECUModel === 'M400') {
                firmwareSource = 'M400'
              } else if (this.packageList[i].ECUModel === 'M400M') {
                firmwareSource = 'M400'
              } else if (target === 'Category') {
                firmwareSource = 'Category'
              } else if (this.packageList[i].IsPublic === true) {
                firmwareSource = 'Motec'
              } else {
                firmwareSource = 'Partner'
                if (this.packageList[i].FirmwareOwners[0] && this.packageList[i].FirmwareOwners[0].WebSite) {
                  website = this.packageList[i].FirmwareOwners[0].WebSite.replace(/^https?:\/\//, '')
                }
              }

              if (make && suits && packageName) {
                make = make.replace(/[^a-zA-Z ]/g, '').trim().toUpperCase()

                let makeSort = make

                if (makeSort === 'TOYOTASUBARU') {
                  makeSort = 'TOYOTA'
                }

                if (makeSort === 'MERCEDES AMG') {
                  makeSort = 'MERCEDES'
                }

                ret.push({
                  Make: make,
                  MakeSort: makeSort,
                  FullSuits: fullSuits,
                  Suits: suits,
                  PackageName: packageName,
                  PackageSlug: packageSlug,
                  IntegrationType: integrationType,
                  FirmwareSource: firmwareSource,
                  Contact: owner,
                  SalesEmail: salesEmailLink,
                  SupportEmail: supportEmailLink,
                  WebSite: website,
                  Target: target
                })
              }
            }
          })
        })
      }

      ret.sort((a, b) => {
        return a.MakeSort.localeCompare(b.MakeSort)
      })

      return ret
    }
  }
}

